import { InferSelectModel, relations } from 'drizzle-orm'
import {
  serial,
  pgEnum,
  pgTable,
  integer,
  text,
  jsonb,
  timestamp,
  unique,
} from 'drizzle-orm/pg-core'

export const OrderState = {
  CONCEPT: 'concept',
  SENT: 'sent',
  DONE: 'done',
  CANCELED: 'canceled',
} as const

export const stateEnum = pgEnum('state', [
  OrderState.CONCEPT,
  OrderState.SENT,
  OrderState.DONE,
  OrderState.CANCELED,
])

export const orders = pgTable('orders', {
  id: text('id').primaryKey(),
  projectJson: jsonb('projectJson'),
  configurationRootId: integer('configurationRootId')
    .notNull()
    .default(1)
    .references(() => configurations.id),
  version: integer('version'),
  userId: integer('userId'),
  salesmanId: integer('salesmanId'),
  country: text('country'),
  region: integer('region'),
  firstName: text('firstName'),
  lastName: text('lastName'),
  company: text('company'),
  phone: text('phone'),
  email: text('email'),
  state: stateEnum('state').notNull(),
  note: text('note'),
  createdAt: timestamp('createdAt', { withTimezone: true })
    .notNull()
    .defaultNow(),
  updatedAt: timestamp('updatedAt', { withTimezone: true })
    .notNull()
    .defaultNow(),
})

export const configurations = pgTable(
  'configurations',
  {
    // TODO: Don't send ID from
    id: serial('id').primaryKey(),
    version: integer('version').notNull(),
    projectJson: jsonb('projectJson').notNull(),
    createdAt: timestamp('createdAt', { withTimezone: true })
      .notNull()
      .defaultNow(),
    previousConfigurationId: integer('previousConfigurationId'),
    rootId: integer('rootId'),
  },
  (t) => ({
    unq: unique().on(t.id, t.version),
  })
)

export const ordersRelations = relations(orders, ({ one }) => ({
  configuration: one(configurations, {
    fields: [orders.configurationRootId],
    references: [configurations.id],
  }),
}))

export const configurationsRelations = relations(configurations, ({ one }) => ({
  previousConfiguration: one(configurations, {
    fields: [configurations.previousConfigurationId],
    references: [configurations.id],
  }),
  root: one(configurations, {
    fields: [configurations.rootId],
    references: [configurations.id],
  }),
}))

export type Order = InferSelectModel<typeof orders>
export type InsertOrder = Omit<
  InferSelectModel<typeof orders>,
  'id' | 'createdAt' | 'updatedAt'
>

export type Configuration = InferSelectModel<typeof configurations>
export type InsertConfiguration = Omit<
  InferSelectModel<typeof configurations>,
  'id' | 'createdAt'
>

export type OrderStateEnum = (typeof stateEnum.enumValues)[number]
